import angular from 'angular';
import {getLocale} from 'acng/locale/model/locale.js';
import {asset} from '../../core/service/env.js';
import templateUrl from '../../../html/payment/newWindow.html';

angular.module('payment').directive('onswPaymentNewWindow', [function () {
  /**
   * @type {angular.IDirective<angular.IScope & {
   *   locale: Function;
   *   toggleConsentForDataStorage: Function;
   * }>}
   */
  const directive = {
    require: '^^ngController',
    scope: {
      payment: '<',
      openAction: '&',
      resetAction: '&'
    },
    templateUrl: asset(templateUrl),
    link: function (scope, element, attr, paymentController) {
      element.addClass('ons-form');
      scope.locale = getLocale;
      scope.toggleConsentForDataStorage = async () => {
        element.addClass('busy');
        // @ts-ignore refactor paymentController
        await paymentController.startTransaction();
        element.removeClass('busy');
      };
    }
  };

  return directive;
}]);
